import { Component } from 'react';

export class ErrorBoundary extends Component {
  state = { error: null };

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // TODO: enviar a Sentry o servicio de logging
    console.error('ErrorBoundary capturó:', error, info);
  }

  render() {
    if (this.state.error) {
      return (
        <div className="alert alert-danger m-3">
          Algo salió mal. Recarga la página o contacta soporte.
        </div>
      );
    }
    return this.props.children;
  }
}
